let burger = document.querySelector('.nav__burger');